import { observer } from 'mobx-react-lite'
import { Button, Icon, Status } from 'shared/ui'
import { TrackConversions } from 'widgets/TrackConversions/ui/TrackConversions'
import type { TrackConversionStore } from 'widgets/TrackConversions/store/trackConversionStore'
import { AiReplies, type AiRepliesStore } from 'widgets/AiReplies'
import styles from './styles.module.scss'

type IAdvancedProps = {
  trackConversionStore: TrackConversionStore
  isTrackConversionVisible?: boolean
  isOpenAdvanced: boolean
  setOpenAdvanced: (isOpen: boolean) => void
  aiRepliesStore?: AiRepliesStore | null
  isNew?: boolean
}

export const AdvancedTrackConversions = observer(
  ({
    trackConversionStore,
    isTrackConversionVisible = true,
    isOpenAdvanced,
    setOpenAdvanced,
    aiRepliesStore,
    isNew,
  }: IAdvancedProps) => {
    const handleOpen = () => {
      setOpenAdvanced(!isOpenAdvanced)
    }
    return (
      <div>
        <Button
          style={{ marginLeft: '-4px' }}
          typeBtn={'text'}
          contained={'secondary'}
          size={'medium'}
          text={
            <>
              Advanced
              {isNew && (
                <Status
                  title={'New'}
                  intent={'purple'}
                  emphasis={'high'}
                  size={'label'}
                  className={styles.listItemContentNew}
                />
              )}
              <Icon
                icon={isOpenAdvanced ? 'chevronUp' : 'chevronDown'}
                className={styles.rightIcon}
              />
            </>
          }
          intent={'passive'}
          onClick={handleOpen}
          advanced
        />
        {isOpenAdvanced && (
          <div className={styles.content}>
            {aiRepliesStore && <AiReplies store={aiRepliesStore} />}
            {isTrackConversionVisible && <TrackConversions store={trackConversionStore} />}
          </div>
        )}
      </div>
    )
  }
)
